import { getFramework, HotkeyType } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPlugin, type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { type ClipboardPlugin } from '../../controller';

export const clipboardPasteItem = (_: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);

    const tryGetClipboard = () => {
        const clipboard = framework.service.registration.getInstance<ClipboardPlugin>('ClipboardPlugin');
        if (!clipboard) {
            throw new Error('ClipboardPlugin is not found');
        }
        return clipboard;
    };

    const disabled = !tryGetClipboard().getClipboardData(null)?.template;

    const type = HotkeyType.PASTE;
    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.paste),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            const { x, y } =
                framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').positionInfo;
            if (framework.service.edgelessCanvas.isEdgelessMode) {
                const point = framework.service.transform.getScenePoint({ x, y });
                tryGetClipboard().paste(null, point, true);
                return;
            }
            const scenePoint = framework.service.transform.getScenePoint({ x, y });
            const activeFrameId = framework.service.frame.getActiveFrameId();
            const frameBaseInfo = framework.service.frame.getBaseInfo(activeFrameId);
            tryGetClipboard().paste(null, {
                x: scenePoint.x - (frameBaseInfo.left || 0),
                y: scenePoint.y - (frameBaseInfo.top || 0),
            });
        },
    };

    return item;
};
